import * as mustcache from "mustcache";

export const render = (element, renderedCallback) => {
  element.html(mustcache.render("upgraded", {}));
  renderedCallback();
};

export const name = "upgradedPage";
export const showHeader = true;
